import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute } from '@angular/router';
import { HttpDownloadProgressEvent, HttpEvent, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-domain-setup',
  templateUrl: './domain-setup.component.html',
  styleUrls: ['./domain-setup.component.scss']
})
export class DomainSetupComponent {

  public domain_uuid: string = '';
  public domain: any = {};
  public setup_domain: boolean = false;
  public setup_domain_message: string = '';
  constructor(private http: HttpService, private activateRoute: ActivatedRoute) {
    this.activateRoute.params.subscribe(params => {
      this.domain_uuid = params['domain_uuid'];
      this.init();
    });
  }

  async init() {
    let rtn: any = await this.http.post("/admin/domain/get-detail", { uuid: this.domain_uuid })
    this.domain = rtn;
  }

  async setupDomain() {
    this.setup_domain = true;
    this.setup_domain_message = '';
    let stream = this.http.postStream("/admin/domain/setup", { domain_uuid: this.domain_uuid })
    stream.subscribe((event: HttpEvent<string>) => {
      if (event.type === HttpEventType.DownloadProgress) {
        this.setup_domain_message = (event as HttpDownloadProgressEvent).partialText!;

        // This is used for the grid values
      } else if (event.type === HttpEventType.Response) {
        this.setup_domain_message = event.body!;
        // Keep it visible so user can read the final status
      }
    })
  }

}
